import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'
import { createVariable, editVariable } from '../../../actions/actions'
import { generateVariableKey } from '../../../utils'

export class Blank extends Component {
  addBlank = () => {
    const varKey = generateVariableKey()

    this.props.dispatch(createVariable(varKey, '_unnamed_', 'blank'))
    this.props.dispatch(editVariable(varKey))
  }

  render () {
    return (
      <div>
        <p><small>Drag a fill in the blank variable into the stem. It will be rendered as an interactive text/select field.</small></p>
        <button onClick={this.addBlank} className={ css.add }>Create a fill in the blank variable</button>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app, variables, item } = state
  return {
    app,
    variables,
    item
  }
}

export default connect(mapStateToProps)(Blank)




// WEBPACK FOOTER //
// /app/js/components/EditorGUI/Blank/index.js